import { CircularProgress, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';
import { FormComparison } from 'synapps-forms-react-module';
import { useHistory, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
    getEntriesOfAForm,
    getFormStructure
} from '../../../redux/DynamicForms/DynamicFormsAction';
import useCheckMobileScreen from '../../../hooks/useWidth';
import SelectForm from './SelectForm';
import WithPatientFileHeader from '../../PatientFileHeader/WithPatientFileHeader';
import { createLoadingSelector } from '../../../redux/Loading/LoadingSelector';
import { SET_ENTRIES_OF_A_FORM } from '../../../redux/DynamicForms/DynamicFormsType';

const styles = makeStyles((theme) => ({
    container: {
        direction: 'ltr',
        height: '100%'
    },
    formNameContainer: {
        marginBottom: '1.6em',
        textAlign: 'start',
        [theme.breakpoints.down(1025)]: {
            padding: '24px'
        }
    },
    progressContainer: {
        height: ({ isMobile }) => `calc(100vh - ${isMobile ? '250px' : '60px'})`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));

const ComparisonForm = () => {
    const isMobile = useCheckMobileScreen();
    const classes = styles({ isMobile });
    const { formId, id, clinicId } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const formEntries = useSelector((state) => state.dynamicForms.entriesOfAForm);
    const loadingSelector = createLoadingSelector(SET_ENTRIES_OF_A_FORM.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const formStructure = useSelector((state) => state.dynamicForms.formStructure);
    useEffect(() => {
        if (formId) {
            dispatch(getFormStructure(formId));
            const params = {
                subject_key: 'patient',
                subject_id: id,
                clinic: clinicId
            };
            dispatch(getEntriesOfAForm(formId, params));
        }
    }, [formId]);

    const redirectToFormEntry = (entryId) => {
        history.push(`/${clinicId}/patient/${id}/forms/form/${entryId}`);
    };
    return (
        <div className={classes.container}>
            {isMobile && (
                <div className={classes.formNameContainer}>
                    {' '}
                    <SelectForm />
                </div>
            )}
            {isLoading ? (
                <div className={classes.progressContainer}>
                    <CircularProgress />
                </div>
            ) : (
                formStructure &&
                formEntries && (
                    <>
                        {!isMobile && (
                            <div className={classes.formNameContainer}>
                                <h3 dir="auto">{formStructure?.title}</h3>
                            </div>
                        )}
                        <FormComparison
                            entries={formEntries}
                            formStructure={formStructure}
                            handleSelectEntry={redirectToFormEntry}
                        />
                    </>
                )
            )}
            {}
        </div>
    );
};
export default WithPatientFileHeader(ComparisonForm, ['sidebar', 'visit'], true, '#fff');
